import { type ProductizedServiceMoreServices_productizedService$key } from '#app/__generated__/relay/ProductizedServiceMoreServices_productizedService.graphql.js';
import { Text } from '#app/components/Primitives/Text.js';
import { getNextItemsInCyclicalList } from '#app/utilities/getNextItemsInCyclicalList.js';
import { ProductizedServiceMoreCard } from './ProductizedServiceMoreCard.js';
import { graphql, useFragment } from '@contra/relay';
import { styled } from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const ProductizedServiceCards = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

type ProductizedServiceMoreServicesProps = {
  readonly productizedServiceRef: ProductizedServiceMoreServices_productizedService$key;
};

export const ProductizedServiceMoreServices = ({
  productizedServiceRef,
}: ProductizedServiceMoreServicesProps) => {
  const {
    id,
    userProfile: {
      productizedServices: { edges },
    },
  } = useFragment<ProductizedServiceMoreServices_productizedService$key>(
    graphql`
      fragment ProductizedServiceMoreServices_productizedService on ProductizedService {
        id
        userProfile {
          productizedServices {
            edges {
              node {
                id
                ...ProductizedServiceMoreCard_productizedService
              }
            }
          }
        }
      }
    `,
    productizedServiceRef,
  );

  const productizedServices = edges.map(({ node }) => node);
  const nextThreeProductizedServices = getNextItemsInCyclicalList({
    amount: 3,
    items: productizedServices,
    targetId: id,
  });

  if (!nextThreeProductizedServices.length) {
    return null;
  }

  return (
    <Container aria-label="more services section">
      <Text textStyle="overline">More services</Text>
      <ProductizedServiceCards>
        {nextThreeProductizedServices.map((service) => (
          <ProductizedServiceMoreCard
            key={service.id}
            productizedServiceRef={service}
          />
        ))}
      </ProductizedServiceCards>
    </Container>
  );
};
